<ng-container *ngIf="layout">
  <ng-template #separator>
    <li class="page-item d-flex justify-content-center align-items-center">
      <span class="page-link text-muted">&bull;&bull;&bull;</span>
    </li>
  </ng-template>

  <nav class="d-flex justify-content-center align-items-center">
    <ul class="pagination d-flex justify-content-center align-items-center">
      <li class="page-item">
        <span
          class="page-link text-primary"
          [class.passive]="layout.previous.previous === null"
          (click)="onClick(layout.previous.previous)">
          Previous
        </span>
      </li>
      <li *ngFor="let page of layout.previous.extremes" class="page-item page-number-item">
        <span class="page-link text-primary" (click)="onClick(page)">{{ page }}</span>
      </li>
      <ng-container *ngIf="layout.previous.extremes.length > 0">
        <ng-template [ngTemplateOutlet]="separator"></ng-template>
      </ng-container>
      <li *ngFor="let page of layout.previous.immediates" class="page-item page-number-item">
        <span class="page-link text-primary" (click)="onClick(page)">{{ page }}</span>
      </li>
      <li class="page-item active page-number-item">
        <span class="page-link" (click)="onClick(current)">{{ current }}</span>
      </li>
      <li *ngFor="let page of layout.next.immediates" class="page-item page-number-item">
        <span class="page-link text-primary" (click)="onClick(page)">{{ page }}</span>
      </li>
      <ng-container *ngIf="layout.next.extremes.length > 0">
        <ng-template [ngTemplateOutlet]="separator"></ng-template>
      </ng-container>
      <li *ngFor="let page of layout.next.extremes" class="page-item page-number-item">
        <span class="page-link text-primary" (click)="onClick(page)">{{ page }}</span>
      </li>
      <li class="page-item">
        <span
          class="page-link text-primary"
          [class.passive]="layout.next.next === null"
          (click)="onClick(layout.next.next)">
          Next
        </span>
      </li>
    </ul>
  </nav>
</ng-container>
